





















































































































































































import { Component } from "vue-property-decorator";
import Hint from "@/views/AutomaticPaymentsOverview/Hint.vue";
import Table from "@/components/Table.vue";
import Actions from "@/components/Actions.vue";
import FileCsvButton from "@/components/Button/FileCsvButton.vue";
import PrintButton from "@/components/Button/PrintButton.vue";
import { namespace } from "vuex-class";
import FscCard from "@/components/Card/FscCard.vue";
import PaymentRequestButton from "@/components/Button/PaymentRequestButton.vue";
import FilterAndSearch from "@/components/FilterAndSearch.vue";
import StudentCol from "@/views/AutomaticPaymentsOverview/StudentCol.vue";
import { CLASSIC_PAY } from "@/constants/PaymentWorkflow";
import TextDecimal from "@/components/TextDecimal.vue";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import MagicStickButton from "@/components/Button/MagicStickButton.vue";
import VerticalDivider from "@/components/VerticalDivider.vue";
import PaymentHeader from "@/views/AutomaticPaymentsOverview/PaymentHeader.vue";
import _ from "lodash";
import { mixins } from "vue-class-component";
import AutomaticPaymentMixin from "@/mixins/AutomaticPaymentMixin";
import FileCheckButton from "@/components/Button/FileCheckButton.vue";
import GenerateStudentInvoiceModal from "@/views/AutomaticPaymentsOverview/GenerateStudentInvoiceModal.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import UnfinishedInvoiceModal from "@/views/AutomaticPaymentsOverview/UnfinishedInvoiceModal.vue";
import GenerateFinalInvoiceConfirmationModal from "@/views/AutomaticPaymentsOverview/GenerateFinalInvoiceConfirmationModal.vue";
import InvoiceDocumentPreview from "@/views/AutomaticPaymentsOverview/InvoiceDocumentPreview.vue";
import PaymentWorkflowFilterModal from "@/components/Modal/PaymentWorkflowFilterModal.vue";

const ClassicPayModule = namespace("classic-pay");
const ClassicPayFilterModule = namespace("classic-pay/localFilter");
const SaldoModule = namespace("saldo");
const AppModule = namespace("app");

@Component({
  components: {
    PaymentWorkflowFilterModal,
    GenerateFinalInvoiceConfirmationModal,
    UnfinishedInvoiceModal,
    GenerateStudentInvoiceModal,
    FileCheckButton,
    PaymentHeader,
    VerticalDivider,
    MagicStickButton,
    FscSimpleCard,
    TextDecimal,
    StudentCol,
    FilterAndSearch,
    PaymentRequestButton,
    FscCard,
    PrintButton,
    FileCsvButton,
    Actions,
    Table,
    Hint,
    SaveButton,
    AbortButton,
    InvoiceDocumentPreview,
  },
})
export default class ClassicPay extends mixins(AutomaticPaymentMixin) {
  public name = "ClassicPay";

  protected filtered = "";

  protected modalId = "classic-pay-modal-id";

  protected studentEducationFields = [
    {
      key: "selected",
      label: "",
      class: "w-30",
    },
    {
      key: "student",
      label: "",
    },
    {
      key: "licenseClass",
      label: this.$t("sidebar.training"),
    },
    {
      key: "payments",
      label: this.$t("automatic_payment.payments_made"),
    },
    {
      key: "actualBalance",
      label: this.$t("automatic_payment.actual_balance"),
    },
    {
      key: "previewBalance",
      label: this.$t("automatic_payment.preview_balance"),
    },
    {
      key: "practicalExamDate",
      label: this.$t("automatic_payment.practical_exam_date"),
    },
    {
      key: "lastPaymentRequestDate",
      label: this.$t("automatic_payment.date_of_last_request_of_payment"),
    },
    {
      key: "finishedEducation",
      label: this.$t("automatic_payment.education_finished"),
    },
    {
      key: "finalInvoiceDate",
      label: this.$t("automatic_payment.date_of_final_invoice"),
    },
  ];

  @ClassicPayFilterModule.State("filter")
  public classicPayLocalFilter: any;

  @ClassicPayFilterModule.Mutation("SET_LOCAL_FILTER")
  public setClassicPayLocalFilter!: (payload: Record<any, any>) => void;

  @ClassicPayModule.Action("findAllStudentList")
  public paymentWorkflowsStudentListFindAll: any;

  @ClassicPayModule.Getter("getStudentList")
  public paymentWorkflowsStudentList: any;

  @ClassicPayModule.Getter("getStudentListTotal")
  public paymentWorkflowsStudentTotal: any;

  @ClassicPayModule.Getter("getStudentListLoading")
  public paymentWorkflowsStudentListLoading: any;

  @ClassicPayModule.Action("findOverviewInfo")
  public findOverviewInfo: any;

  @ClassicPayModule.Getter("getOverviewInfo")
  public getOverviewInfo: any;

  @ClassicPayModule.Getter("getOverviewInfoLoading")
  public getOverviewInfoIsLoading: any;

  @SaldoModule.Action("findOne")
  public findAllPaymentWorkflowBalance: any;

  @AppModule.Action("setSelectedClassicPayStudents")
  public setSelectedClassicPayStudents: any;

  public requestQuery(query: Record<any, any> | null): void {
    this.query = query;
    this.paymentWorkflowsStudentListFindAll({
      ...this.query,
      studentName: query?.searchTerm,
      ...this.paymentFilter,
      paymentWorkflowId: CLASSIC_PAY,
    });
  }

  protected onChangeFilter(): void {
    (this.$refs.educationTable as Table).onSearch(this.filtered);
  }

  public async mounted(): Promise<void> {
    this.cachedFilter();
    await this.findOverviewInfo(CLASSIC_PAY);
    await this.findAllPaymentWorkflowBalance({
      id: CLASSIC_PAY,
      resource: "balance/payment-workflow",
    });
    this.$root.$on("before-destroyed-component", (props: any) => {
      if (_.isBoolean(props.success) && props.success && props.component == this.name) {
        this.requestQuery(this.query);
      }
    });
  }

  protected get classicPay(): number {
    return CLASSIC_PAY;
  }

  protected async onClickPaymentRequest(): Promise<void> {
    if (this.hasNotPermissionWrite) return;
    await this.setSelectedClassicPayStudents([...this.selectedResources]);
    if (this.selectedResources.length !== 0) {
      await this.$router.push({ name: "PaymentRequest" });
    }
  }

  protected createFinalInvoiceConfirmed() {
    this.$bvModal.hide(this.modalId);
    // await this.ok();
  }

  private onFilterHandle() {
    this.setClassicPayLocalFilter({
      filter: this.paymentFilter,
      active: this.appliedFilter,
    });
    this.onFilter();
  }

  private cachedFilter() {
    if (this.classicPayLocalFilter instanceof Object) {
      const { filter, active } = this.classicPayLocalFilter;
      this.paymentFilter = filter;
      this.appliedFilter = active;
    }
  }
}
